import { render, staticRenderFns } from "./DisposeComplaint.vue?vue&type=template&id=2f3a49b8"
import script from "./DisposeComplaint.vue?vue&type=script&lang=js"
export * from "./DisposeComplaint.vue?vue&type=script&lang=js"
import style0 from "./DisposeComplaint.vue?vue&type=style&index=0&id=2f3a49b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports